<template lang="pug">
  .asp-service
    h2.primary--text Info

    v-expansion-panels.mt-5(flat tile multiple)
      v-expansion-panel.my-1(v-for="(cl, i) in changeLogs" :key="i")
        v-expansion-panel-header
          h4 {{ cl.title }}

        v-expansion-panel-content.pt-4(eager)
          ul
            li(v-for="(l, k) in cl.logs" :key="k") {{ l }}

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class Profile extends Vue {
  changeLogs = [
    {
      title: 'RiMaS Version 1.0',
      logs: [
        'Grundfunktionalität'
      ]
    },
    {
      title: 'RiMaS Version 1.1',
      logs: [
        'Mandantenfähigkeit RiMaS für Saarland und Berlin'
      ]
    },
    {
      title: 'RiMaS Version 1.2',
      logs: [
        'Anpassung Transportrisiken',
        'Liste Rechtsformen',
        'Hinweis auf noch nicht ausgefüllte Felder',
        'Tausender-Trennzeichen schon bei Eingabe für mehr Übersichtlichkeit',
        'Tooltip zum Begriff "EWR" ergänzen.',
        'Sub-Kategorien einklappbar',
        'Möglichkeit ergänzen, alle Abschnitte einer Seite per Mausklick zuzuklappen',
        'Vereinheitlichung von "Weiteres Gebäude" / "Weiterer Standort"',
        'Austausch Icon "Agentur wählen"',
        'Änderung / Erweiterung von Standorten / Gebäuden während laufender Beratung',
        'Abschnitt Kundenpräferenz',
        'Erweiterung Druckausgabe Status',
        'Duplizieren einer Beratung',
      ]
    },
    {
      title: 'RiMaS Version 1.3',
      logs: [
        'Kleinere Anpassungen aus QS',
        'Statistik RiMaS',
        'Löschung Beratung / Kunde nach Zeitversatz',
        'Optimierung Tastaturbedienung der Anwendung',
        'Change-Log in der Anwendung',
      ]
    },
    {
      title: 'RiMaS Version 1.4',
      logs: [
        'Konzeptvorschlag zusätzlich verfügbar',
        'Kleinere Bugfixes und Optimierungen',
      ]
    },
    {
      title: 'RiMaS Version 1.5',
      logs: [
        'Optimierung Statistik',
        'Seitennavigation zu WIN- / LOSS-Analyse',
      ]
    },
    {
      title: 'RiMaS Version 1.6',
      logs: [
        'Erfassung Risikosumme Maschinen detailliert',
        '5%-Puffer bei Maschinen und Maschinenausfall für marginale Unterschreitung Risikosumme',
        'Bugfix Transportrisiken in Konzept',
        'Positiv-Meldungen für Inventar in Status und Konzept',
        'Anpassung Logik Wertermittlung / Mietausfall',
        'Individuelle Infotexte pro Inventarklasse',
        'Anpassung Infotexte, aktuelle Werte für 1971-Wert',
        'Kleinere Anpassungen und Formatierungen',
      ]
    },
    {
      title: 'RiMaS Version 1.7 / 1.8',
      logs: [
        'Fix Sachwerte Maschinen Bezugsjahr',
        'Fix Berufshaftpflicht',
        'Diverse Bug-Fixes',
        'Ausnahmen für Lösch-Automatismus',
      ]
    }
  ]
}
</script>
